import { PageLoading } from 'components/loading'
import { useAtividadeColetivaVisualizarReuniaoQuery } from 'graphql/hooks.generated'
import { Redirect, useParams } from 'react-router'

import { AtividadeColetivaVisualizarReuniaoView } from './AtividadeColetivaVisualizarReuniaoView'

interface AtividadeColetivaReuniaoViewParams {
  atividadeColetivaId: ID
}

export function AtividadeColetivaReuniaoView() {
  const { atividadeColetivaId } = useParams<AtividadeColetivaReuniaoViewParams>()

  const {
    data: { atividadeColetiva },
    loading,
  } = useAtividadeColetivaVisualizarReuniaoQuery({
    variables: { atividadeColetivaId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!atividadeColetiva) {
    return <Redirect to='/404' />
  } else {
    return <AtividadeColetivaVisualizarReuniaoView atividadeColetiva={atividadeColetiva} isFonteDadosPec={true} />
  }
}
